import { DashboardModuleArea, DashboardModuleZoneArea } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { uniqueId } from 'lodash'

export interface DashboardViewsAnalyticAreasState {
    areas: DashboardModuleZoneArea[]
}
export const initialDashboardViewsAnalyticAreasState =
    (): DashboardViewsAnalyticAreasState => ({
        areas: [
            {
                id: uniqueId(),
                area: DashboardModuleArea.PENDING_ELEMENTS,
                options: {}
            },
            {
                id: uniqueId(),
                area: DashboardModuleArea.CHARTS,
                options: {
                    isWidgetFillToWidth: true,
                    isWidgetFillToHeight: true
                }
            },
            {
                id: uniqueId(),
                area: DashboardModuleArea.INTEREST_DATA,
                options: {}
            }
        ]
    })
